import React from "react";
import AmlTable from "../AmlTable";
import { Box } from "@mui/material";

const AmlPending = ({ handleOpenLegendaModal, allAml }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <AmlTable
        data={allAml}
        onStatusInfoClick={handleOpenLegendaModal}
        emptyMessage="Non ci sono aml in raccolta"
      />
    </Box>
  );
};

export default AmlPending;
